import { WallClockDate, WallClockDateService } from '@mews/framework/datetime';
import { DistributorTextKey as TextKey } from '../enums/DistributorTextKey';

export const getShortDayNameKey = (wallClockDate: WallClockDate) => {
    const day = WallClockDateService.getDay(wallClockDate);
    return DAY_SHORT_NAME_KEYS[day];
};

const DAY_SHORT_NAME_KEYS = [
    TextKey.DayShortSunday,
    TextKey.DayShortMonday,
    TextKey.DayShortTuesday,
    TextKey.DayShortWednesday,
    TextKey.DayShortThursday,
    TextKey.DayShortFriday,
    TextKey.DayShortSaturday,
];
